import cx from 'classnames';
import { asset } from '../../../../../../../shared/frontend/services/assetResolverService';
import { Link } from '../../../../../../../shared/frontend/components/link';
import { InteractiveStreamPreview, XX_LARGE_SIZE } from './shared';

interface MDIBlizzardFeatureProps {
  streamers: Array<{
    stream: {
      name: string;
      thumbnail_url: string;
      viewer_count: number;
    };
  }>;
  className?: string;
  currentFeatures: {
    stream_feature_warcraftmdi: boolean;
    params?: Record<string, string | undefined>;
  };
}

export function isMDIBracketActive(props: MDIBlizzardFeatureProps) {
  return (
    props.currentFeatures.stream_feature_warcraftmdi &&
    props.streamers.length &&
    props.streamers[0].stream?.name.toLowerCase() === 'warcraft'
  );
}

export function MDIBlizzardFeature(props: MDIBlizzardFeatureProps) {
  const streamSize = XX_LARGE_SIZE;
  const params = props.currentFeatures?.params || {};

  const link1Text = params.mdi_masthead_link_1_text || 'Bracket';
  const link1Url = params.mdi_masthead_link_1_url || '/events/mdi-midnight-season-1/brackets/china-region-finals';
  const link2Text = params.mdi_masthead_link_2_text || 'Event Details';
  const link2Url = params.mdi_masthead_link_2_url || '/events/mdi-midnight-season-1/info';

  const primaryStream = {
    live: true,
    autoplay: true,
    ...(props.streamers[0] ?? {}),
    size: streamSize,
    className: 'rio-hidden--small slds-col slds-grow-none'
  };

  const IMAGE_FOLDER_PATH = '/images/events/expansion11/mdi-midnight-season-1';

  return (
    <div
      className={cx(
        'rio-fuzzy-border rio-fuzzy-border--large slds-text-align--center slds-m-bottom--small slds-grid slds-wrap slds-nowrap--large slds-grid--vertical-align-center slds-grid--align-center slds-p-around--small',
        props.className
      )}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${asset(
          `${IMAGE_FOLDER_PATH}/mdi_bg.jpg`
        )})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center'
      }}
    >
      <div className="rio-hidden--small slds-col slds-shrink-none slds-grow-none slds-p-right--x-large">
        <Link to={link1Url}>
          <img
            src={asset(`${IMAGE_FOLDER_PATH}/mdi_logo.png`)}
            alt="Mythic Dungeon International"
            style={{ width: 250 }}
          />
        </Link>
        <div>
          <Link to={link1Url} className="rio-realm-link slds-text-heading--small text-white text-bold">
            <b>{link1Text}</b>
          </Link>
          &nbsp; | &nbsp;
          <Link to={link2Url} className="rio-realm-link slds-text-heading--small text-white text-bold">
            <b>{link2Text}</b>
          </Link>
        </div>
      </div>
      <div className={cx('slds-col slds-max-small-size--1-of-1 slds-m-top--small')}>
        <div className={cx('d-inline-block slds-m-top--small')}>
          <InteractiveStreamPreview
            key={primaryStream.stream.name}
            type="twitch"
            thumbnailUrl={primaryStream.stream.thumbnail_url}
            width={primaryStream.size.width}
            height={primaryStream.size.height}
            thumbnailWidth={primaryStream.size.width}
            thumbnailHeight={primaryStream.size.height}
            viewerCount={primaryStream.stream.viewer_count}
            streamIdentifier={primaryStream.stream.name}
            isFeatured={true}
            live={primaryStream.live}
            autoplay={primaryStream.autoplay}
            className={cx('stream--larger', primaryStream.className)}
          />
        </div>
      </div>
    </div>
  );
}
